import type { ReactNode } from "react";
import { BrandMark } from "../../components/ui/Brand.js";

export const SIM_BANNER_TEXT = "MODO SIMULACIÓN — DATOS SINTÉTICOS";

export function SimulationBanner() {
  return (
    <div
      role="status"
      data-testid="simulation-banner"
      className="pointer-events-none fixed left-1/2 top-2 z-[60] -translate-x-1/2 rounded bg-amber-400 px-3 py-1 text-xs font-bold tracking-wide text-amber-950 shadow"
    >
      {SIM_BANNER_TEXT}
    </div>
  );
}

/** Pantalla de instrucciones sencilla y centrada (sin navegación). */
export function Panel({ title, children, wide = false }: { title: string; children: ReactNode; wide?: boolean }) {
  return (
    <main className="flex min-h-full flex-col items-center justify-center gap-6 bg-paper px-4 py-12">
      <BrandMark tone="light" size={28} />
      <section
        className={`w-full ${wide ? "max-w-3xl" : "max-w-xl"} rounded-[18px] border border-slate-200 bg-white p-8 shadow-sm`}
        aria-labelledby="panel-title"
      >
        <h1 id="panel-title" className="text-2xl font-bold text-ink">
          {title}
        </h1>
        <div className="mt-4 space-y-4 text-slate-700">{children}</div>
      </section>
    </main>
  );
}

export function Actions({ children }: { children: ReactNode }) {
  return <div className="flex flex-wrap items-center gap-3 pt-2">{children}</div>;
}

export function ErrorText({ children }: { children: ReactNode }) {
  return (
    <p role="alert" className="rounded-md bg-rose-50 p-3 text-sm text-rose-800">
      {children}
    </p>
  );
}

/** Textos según la composición de los estímulos (solo imágenes, solo videos o ambos). */
export function stimulusWords(mix: "image" | "video" | "mixed") {
  if (mix === "video") return { one: "video", each: "cada video", plural: "los videos", current: "el video actual", unused: "el video que se estaba mostrando no se usará", remaining: (n: number) => (n === 1 ? "video restante" : "videos restantes") };
  if (mix === "mixed")
    return { one: "imagen o video", each: "cada imagen o video", plural: "las imágenes y los videos", current: "la imagen o el video actual", unused: "la imagen o el video que se estaba mostrando no se usará", remaining: (n: number) => (n === 1 ? "elemento restante" : "elementos restantes") };
  return { one: "imagen", each: "cada imagen", plural: "las fotografías", current: "la imagen actual", unused: "la imagen que se estaba mostrando no se usará", remaining: (n: number) => (n === 1 ? "imagen restante" : "imágenes restantes") };
}

export function fmt(n: number | null | undefined, digits = 0, suffix = ""): string {
  if (n === null || n === undefined || !Number.isFinite(n)) return "—";
  return `${n.toFixed(digits)}${suffix}`;
}
